import * as angular from 'angular';

export class CostsService {
    constructor() {}

    calculateMaterialGrossValue(netPrice, vatRate, quantity) {
        if (netPrice && quantity) {
            netPrice = +netPrice;
            vatRate = +vatRate;
            quantity = +quantity;
            let netValue = +(netPrice * quantity).toFixed(2);
            return +(netValue + (netValue * vatRate) / 100).toFixed(2);
        } else {
            return;
        }
    }

    calculateLabourGrossValue(duration, hourlyRate) {
        if (duration && hourlyRate) {
            let durationPieces = duration.split(':');
            let totalSeconds =
                +durationPieces[0] * 3600 + +durationPieces[1] * 60;
            hourlyRate = +hourlyRate;
            return +(hourlyRate * (totalSeconds / 3600)).toFixed(2);
        } else {
            return;
        }
    }

    canUserManageCosts(issue, companyEmployee): boolean {
        return (
            issue &&
            (companyEmployee.manager ||
                this.isUserAssignedToIssue(issue, companyEmployee) ||
                this.isUserAdditionallyAssignedToIssue(issue, companyEmployee))
        );
    }

    isUserAssignedToIssue(issue, companyEmployee): boolean {
        return issue.assigned_to === companyEmployee.user;
    }

    isUserAdditionallyAssignedToIssue(issue, companyEmployee): boolean {
        return issue.additionally_assigned_to.some(
            (x) => x.user_id === companyEmployee.user
        );
    }
}

angular.module('app').service('CostsService', CostsService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/costs.service.ts